/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    ValidatorHistoryAllOf,
    ValidatorHistoryAllOfFromJSON,
    ValidatorHistoryAllOfFromJSONTyped,
    ValidatorHistoryAllOfToJSON,
    ValidatorHistoryPoint,
    ValidatorHistoryPointFromJSON,
    ValidatorHistoryPointFromJSONTyped,
    ValidatorHistoryPointToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidatorHistory
 */
export interface ValidatorHistory {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof ValidatorHistory
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof ValidatorHistory
     */
    is_total_count_clipped: boolean;
    /**
     * The staking address of the validator.
     * @type {string}
     * @memberof ValidatorHistory
     */
    address?: string;
    /**
     * 
     * @type {Array<ValidatorHistoryPoint>}
     * @memberof ValidatorHistory
     */
    history: Array<ValidatorHistoryPoint>;
}

export function ValidatorHistoryFromJSON(json: any): ValidatorHistory {
    return ValidatorHistoryFromJSONTyped(json, false);
}

export function ValidatorHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'history': ((json['history'] as Array<any>).map(ValidatorHistoryPointFromJSON)),
    };
}

export function ValidatorHistoryToJSON(value?: ValidatorHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'address': value.address,
        'history': ((value.history as Array<any>).map(ValidatorHistoryPointToJSON)),
    };
}


